// Generated by CoffeeScript 1.12.7
var Container, clearCache, evaluateType, getFullPath, getPath, isRelative, joinPaths, normalize, populateContainer;

Container = require('./container');

normalize = require('path').normalize;

isRelative = function(path) {
  return path.indexOf('.') === 0;
};

joinPaths = function(arr) {
  return arr.join('/');
};

getFullPath = function(path, basePath) {
  if (typeof window !== "undefined" && window !== null) {
    if (isRelative(path) && basePath !== '') {
      return normalize(joinPaths([basePath, path]));
    } else {
      return path;
    }
  } else if (isRelative(path)) {
    return joinPaths([basePath, path]);
  } else {
    return joinPaths([basePath, 'node_modules', path]);
  }
};

evaluateType = function(moduleConfig, module) {
  var path;
  if (moduleConfig.type != null) {
    return moduleConfig.type;
  }
  path = moduleConfig.require || moduleConfig;
  if (typeof module === 'function' && isRelative(path)) {
    return 'factory';
  } else {
    return 'value';
  }
};

getPath = function(moduleConfig) {
  if (typeof moduleConfig === 'string') {
    return moduleConfig;
  } else {
    return moduleConfig.require;
  }
};

clearCache = function(modules, basePath) {
  return Object.keys(modules).forEach(function(key) {
    var fullPath, moduleConfig, path;
    moduleConfig = modules[key];
    path = getPath(moduleConfig);
    fullPath = getFullPath(path, basePath);
    return delete require.cache[require.resolve(fullPath)];
  });
};

populateContainer = function(di, modules, basePath) {
  return Object.keys(modules).forEach(function(key) {
    var e, fullPath, module, moduleConfig, path, type;
    moduleConfig = modules[key];
    path = getPath(moduleConfig);
    fullPath = getFullPath(path, basePath);
    try {
      module = require(fullPath);
    } catch (error) {
      e = error;
      module = require(path);
    }
    type = evaluateType(moduleConfig, module);
    if (type === 'spread') {
      return di.spread(module);
    } else {
      return di[type](key, module);
    }
  });
};

module.exports = function(options) {
  var basePath, config, configParents, di, modules, opts, parents;
  config = options.config, basePath = options.basePath, opts = options.opts, parents = options.parents;
  if (config == null) {
    throw new TypeError('No configuration was provided for loadConfig');
  }
  if ((options != null ? options.clearCache : void 0) === true) {
    clearCache(modules, basePath);
  }
  di = new Container(opts, parents);
  modules = config.modules || {};
  configParents = config.parents || [];
  configParents.forEach(function(p) {
    var parentModules;
    parentModules = require(joinPaths([p.nodeModule, p.configFile]));
    return populateContainer(di, parentModules.modules, p.nodeModule);
  });
  populateContainer(di, modules, basePath);
  return di;
};
